/**
 * Registers the PWA service worker (`public/sw.js`).
 *
 * Only runs on a production build: during `vite dev` the worker would cache
 * module URLs and shadow HMR, which is a confusing way to lose an afternoon.
 */
export const registerServiceWorker = (): void => {
  if (!import.meta.env.PROD) return
  if (!('serviceWorker' in navigator)) return

  // Registering after `load` keeps the worker's install off the critical path
  // of the first paint.
  window.addEventListener(
    'load',
    () => {
      // Re-checked here, not just above: the listener fires a turn later, so
      // this guard is what actually holds at call time.
      if (!('serviceWorker' in navigator)) return

      // A failed registration costs offline support, not the app — the site
      // works perfectly well unregistered, so swallow it rather than letting
      // an unhandled rejection surface.
      void navigator.serviceWorker.register('/sw.js').catch(() => {
        /* offline support unavailable; the app runs unregistered */
      })
    },
    { once: true },
  )
}
